import styled from 'styled-components';
const ImageStyle = styled.div `
	--core_proportion: 50%;

	&.image-cont {
		position: relative;
		padding-top: var(--core_proportion);

		img {
			width: 100%;
			height: 100%;
			position: absolute;
			inset: 0;
			object-fit: cover;
			object-position: center;
			z-index: 1;
		}
	}
`;
export default ImageStyle;
//# sourceMappingURL=style.js.map